import React, { Fragment } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import AbstractComponent from './component/AbstractComponent';
import Register from './component/cliente/Register';
import Login from './component/login/Login';
import NaoEncontrado from './component/naoencontrado/NaoEncontrado';
import Admin from './Admin';

import { getAppDir } from './helper/Url';

import './css/style.css';

class App extends AbstractComponent {               
    route() {
        if(!this.isLogged())
            return (   
                <Fragment>
                    <Route 
                        exact 
                        path={getAppDir()}
                        render={props => 
                            <Login
                                {...props}
                                
                                route={(item) => this.browserRoute.history.push(item.link)}
                            />
                        }
                    />                    

                    <Route                         
                        path={getAppDir() + '*'}
                        render={props => 
                            <Login
                                {...props}
                                
                                route={(item) => this.browserRoute.history.push(item.link)}
                            />
                        }
                    />
                </Fragment>
            );
          
        return (
            <Route 
                path={getAppDir()} 
                render={props => 
                    <Admin
                        {...props}

                        route={(item) => this.browserRoute.history.push(item.link)}
                    />
                }
            />
        );
    }       

    render() {
        return (     
            <BrowserRouter ref={(ref) => this.browserRoute =  ref}>
                <Switch>                                         
                    <Route 
                        exact 
                        path={getAppDir() + 'register'}
                        render={props => 
                            <Register
                                {...props}
                                    
                                route={(item) => this.browserRoute.history.push(item.link)}
                            />
                        }
                    /> 

                    <Route 
                        exact 
                        path={getAppDir() + 'login'}
                        render={props => 
                            <Login
                                {...props}
                                    
                                route={(item) => this.browserRoute.history.push(item.link)}
                            />
                        }
                    /> 

                    {this.route()}                                        
                    
                    <Route path="*" component={NaoEncontrado}/>
                </Switch>
            </BrowserRouter>        
        )
    }
}

export default App;